<template>
  <v-row dense>
    <v-col cols="12">
      <v-autocomplete
        label="Épület"
        :error-messages="errors.building_id"
        v-model="value.buildingId"
        :items="buildings"
        item-text="name"
        item-value="id"
        filled
        :value-comparator="$config.comparators.isEqual"
      />
    </v-col>

    <v-col cols="12">
      <v-autocomplete
        label="Épület szint"
        :error-messages="errors.building_level_id"
        v-model="value.buildingLevelId"
        :items="buildingLevels"
        item-text="name"
        item-value="id"
        :value-comparator="$config.comparators.isEqual"
        filled
        :disabled="!value.buildingId"
      />
    </v-col>

    <v-col cols="6">
      <v-masked-text-field
        label="X koordináta"
        :error-messages="errors.x_coord"
        v-model="value.xCoord"
        filled
        :mask="
          $config.inputMasks.createNumberMask({
            allowDecimal: true,
            allowNegative: true,
            min: -90,
            max: 90,
          })
        "
      />
    </v-col>

    <v-col cols="6">
      <v-masked-text-field
        label="Y koordináta"
        :error-messages="errors.y_coord"
        v-model="value.yCoord"
        filled
        :mask="
          $config.inputMasks.createNumberMask({
            allowDecimal: true,
            allowNegative: true,
            min: -90,
            max: 90,
          })
        "
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },

    errors: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      localValue: this.value,
    };
  },

  watch: {
    value(value) {
      this.localValue = value;
    },
    localValue: {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },
  },

  asyncComputed: {
    buildings: {
      async get() {
        const response = await this.$http.get('buildings/list');
        return response.buildings;
      },
      default: [],
    },

    buildingLevels: {
      async get() {
        const response = await this.$http.post('building-levels/list', {
          building_id: this.localValue.buildingId,
        });
        return response.building_levels;
      },
      default: [],
      shouldUpdate() {
        return this.localValue.buildingId > 0;
      },
    },
  },
};
</script>
